import BasicLayout from '@components/layout/BasicLayout'
import Container from '@components/layout/Container'
import Sentius from '@components/sentius/Sentius'
import PageSeo from '@components/seo/PageSeo'
import FixedBg from '@components/shapes/FixedBg'
import getDynasties from '@operations/queries/getDynasties'
import getSentiusEvolutions from '@operations/queries/getEvolutions'
import getSentius, { getSentiusCount } from '@operations/queries/getSentius'
import getSiteSettings from '@operations/queries/getSiteSettings'
import useMediaQuery, { maxWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import { useTheme } from 'styled-components'

const SentiusPage = ({ data: { sentius, evolutions, siteSettings, dynastiesList } }) => {
  const isMobile = useMediaQuery(maxWidthQueries.sm)
  const theme = useTheme()

  if (!sentius) return null
  return (
    <BasicLayout
      dynastiesList={dynastiesList}
      footerLinks={siteSettings?.footerLinks}
      footerLogo={siteSettings?.footerLogo?.url}
      headerLinks={siteSettings?.headerLinks}
      headerLogo={siteSettings?.logo?.url}
      socialLinks={siteSettings?.socialLinks}
    >
      <Container align="center" justify="center" maxWidth="100%" padding="0">
        <FixedBg backgroundSize="500px" />
        <Container
          align="center"
          background={{ backgroundColor: theme.colors.white }}
          justify="center"
          paddingTop={isMobile ? '0rem' : '6rem'}
          position="relative"
          wrap="wrap"
        >
          <PageSeo
            description={sentius.description || undefined}
            image={sentius.frontImage?.formats?.medium?.url || undefined}
            title={`${sentius.name} | Sentius | Sentipedia | Skyclimbers`}
          />
          <Sentius evolutions={evolutions} sentius={sentius} />
        </Container>
      </Container>
    </BasicLayout>
  )
}

export const getStaticPaths = async () => {
  const sentiusCount = await getSentiusCount()
  const sentiusList = await getSentius(`&_limit=${sentiusCount}`)
  const paths =
    sentiusList?.map(sentius => {
      return { params: { slug: [sentius.slug] } }
    }) || []
  return {
    fallback: false,
    paths,
  }
}

export const getStaticProps = async ({ params }) => {
  const { slug } = params
  const sentius = await getSentius(`slug_eq=${slug}`)
  const evolutions = await getSentiusEvolutions(slug)
  let dynastiesList = []
  const siteSettings = await getSiteSettings()

  dynastiesList = await getDynasties()
  return {
    props: {
      data: {
        dynastiesList: dynastiesList || null,
        evolutions: evolutions?.[0] || null,
        sentius: sentius?.[0] || null,
        siteSettings: siteSettings || null,
        slug: slug || '',
      },
    },
    revalidate: false,
  }
}

export default SentiusPage
